module.exports = __webpack_public_path__ + "img/quiz-skate-2.7da12f0c.jpg";